<template>
  <div id="app">
    <Navigation></Navigation>  
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import Navigation from "./components/common/Navigation";
import Footer from "./components/common/Footer";
export default {
  name: 'App',
  components: {
    Footer,
    Navigation,
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue